import {CHANGE_DATA, REMOVE_DATA, REPLACE_DATA} from './types';

/**
 * Change data by key(s)
 * @param {PreActionDataShape} data
 * @returns ActionDataShape
 */
export const changeData = (data: PreActionDataShape): ActionDataShape => ({
    type: CHANGE_DATA,
    ...data,
});

/**
 * Remove data by key(s)
 * @param {PreActionDataShape} data
 * @returns ActionDataShape
 */
export const removeData = (data: PreActionDataShape): ActionDataShape => ({
    type: REMOVE_DATA,
    ...data,
});

/**
 * Replace data by key(s)
 * @param {PreActionDataShape} data
 * @returns ActionDataShape
 */
export const replaceData = (data: PreActionDataShape): ActionDataShape => ({
    type: REPLACE_DATA,
    ...data,
});